import React, { useEffect } from "react";
import HeadSection from "../components/contact/HeadSection";
import MainSection from "../components/contact/MainSection";
import Footer from "../components/footer/Footer";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    alignContent: "center",
    height: '300px',
    backgroundColor: theme.palette.primary.main,
    flexGrow: 1,
  },
}));

export default function Contact({ setTab }) {
  useEffect(() => setTab("Contact"), [setTab]);
  const classes = useStyles();

  return (
    <Box height='94vh' display='flex' flexDirection='column'>
      <HeadSection />
      <Box className={classes.wrapper}>        
        <MainSection />
      </Box>
      <Footer />
    </Box>
  );
}
